import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    gap: 10px;
`;

export const Intructions = styled.h3`
    margin: 0;
`;
